<div
  class="form-group align-self-end {{
    control && !!control.invalid ? 'fg-invalid' : 'fg-valid'
  }} {{ required ? 'fg-required' : '' }} {{ settings.class }}"
  *ngIf="settings"
>
  <label for="input-{{ settings.fieldName | titlecase }}">
    {{ settings.label }}
    <span
      *ngIf="required && !disabled && !settings.disableAsterisk"
      class="text-danger required-asterisk-sign"
      >*</span
    >
  </label>
  <div class="" dropdown [insideClick]="true" placement="bottom left">
    <div
      [ngClass]="{
        'd-flex input-group': true,
        'filled-out': data
      }"
      [class]="settings.customInputClass"
    >
      <ng-select
        id="input{{ settings.fieldName | titlecase }}"
        name="input{{ settings.fieldName | titlecase }}"
        [multiple]="true"
        [items]="options"
        bindLabel="value"
        bindValue="id"
        [(ngModel)]="data"
        [clearable]="false"
        [compareWith]="compareWith"
        [readonly]="disabled"
        placeholder="{{ settings.placeholder }}"
        (change)="onValueChange($event)"
      >
      </ng-select>
      <div class="input-group-append">
        <button
          type="button"
          *ngIf="!settings.hideResetInput && !disabled"
          class="input-group-text"
          tabindex="-1"
          [disabled]="disabled"
          (click)="onClearInput()"
        >
          <span class="oi oi-x"></span>
        </button>
      </div>
    </div>
    <div class="error-message" *ngIf="showError">
      {{ errors[0] }}
    </div>
  </div>
</div>
